module.exports = __webpack_public_path__ + "static/media/support-user-female.f67f3248.png";